/** Consume only the email confirmation fragment. Other app hashes are routes. */
export function takeConfirmationFragment(
  location: Pick<Location, "href">,
  history: Pick<History, "state" | "replaceState">,
  previousHref?: string
): string | null {
  const arrival = new URL(location.href);
  if (!arrival.hash.startsWith("#confirm=")) return null;

  const fields = new URLSearchParams(arrival.hash.slice(1));
  const token = fields.size === 1 ? fields.get("confirm") ?? "" : "";
  const clean = new URL(arrival);
  clean.hash = "";
  if (previousHref) {
    const previous = new URL(previousHref, arrival);
    if (previous.origin === arrival.origin && !previous.hash.startsWith("#confirm=")) {
      clean.pathname = previous.pathname;
      clean.search = previous.search;
      clean.hash = previous.hash;
    }
  }
  // WHY [BOL-PRODUCT-CONFIRM-EDGE-LOG-001]: fragment is browser-only, but
  // leaving it in history permits accidental later sharing. Consume it before
  // any auth/session request; never put the token in a URL, history state,
  // storage, or diagnostic event. The only transfer is the existing POST body.
  history.replaceState(history.state, "", `${clean.pathname}${clean.search}${clean.hash}`);
  return /^[A-Za-z0-9_-]{32,512}$/u.test(token) ? token : "";
}
